export const FLAG_SEQUENCE = [
  "🇺🇸",
  "🇬🇧",
  "🇨🇦",
  "🇦🇺",
  "🇩🇪",
  "🇫🇷",
  "🇪🇸",
  "🇮🇹",
  "🇳🇱",
  "🇸🇪",
  "🇨🇭",
  "🇳🇴",
  "🇩🇰",
  "🇵🇱",
  "🇷🇺",
  "🇦🇹",
  "🇧🇪",
  "🇮🇪",
  "🇫🇮",
  "🇵🇹",
  "🇬🇷",
  "🇯🇵",
  "🇰🇷",
  "🇨🇳",
  "🇮🇳",
  "🇸🇬",
  "🇭🇰",
  "🇹🇭",
  "🇻🇳",
  "🇵🇭",
  "🇮🇩",
  "🇲🇾",
  "🇧🇷",
  "🇦🇷",
  "🇲🇽",
  "🇨🇱",
  "🇨🇴",
  "🇵🇪",
  "🇺🇾",
  "🇪🇨",
  "🇸🇦",
  "🇦🇪",
  "🇹🇷",
  "🇮🇱",
  "🇪🇬",
  "🇿🇦",
  "🇳🇬",
  "🇰🇪",
  "🇬🇭",
  "🇲🇦",
  "🇶🇦",
  "🇰🇼",
  "🇯🇴",
  "🇱🇧",
  "🇧🇭",
  "🇴🇲",
  "🇵🇰",
  "🇱🇰",
  "🇧🇩",
  "🇳🇵",
  "🇲🇳",
  "🇰🇿",
  "🇺🇿",
  "🇦🇿",
  "🇬🇪",
  "🇦🇲",
  "🇺🇦",
  "🇧🇾",
  "🇱🇹",
  "🇱🇻",
  "🇪🇪",
  "🇨🇿",
  "🇸🇰",
  "🇭🇺",
  "🇷🇴",
  "🇧🇬",
  "🇭🇷",
  "🇷🇸",
  "🇸🇮",
  "🇲🇰",
  "🇦🇱",
  "🇧🇦",
  "🇲🇪",
  "🇲🇹",
  "🇨🇾",
  "🇱🇺",
  "🇱🇮",
  "🇦🇩",
  "🇲🇨",
  "🇸🇲",
  "🇻🇦",
]

export const FLAG_SCROLL_DURATION = 70
